import * as React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Box, TextInput, Group, Button, Switch, NumberInput } from '@mantine/core'
import { isNotEmpty, useForm } from "@mantine/form";
import axios from 'axios';
import type { IResponse } from "../../types/api";
import { showMessage } from "../../lib/notification";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import type { IVersion } from "./types";
import Page from "../../components/layout/Page";
import { useFormStyles } from "../../styles/form";

interface FormValues extends Pick<IVersion, 'isForceUpdate' | 'versionCode' | 'versionNumber' | 'os'> {

}

const EditBanner = () => {

    const { state: id = null } = useLocation();

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            isForceUpdate: false,
            versionCode: '',
            versionNumber: 0,
            os: 'android'
        },

        validate: {
            versionCode: isNotEmpty('Хувилбарын код оруулна уу'),
            versionNumber: isNotEmpty('Хувилбарын дугаар оруулна уу'),
        },
    });

    React.useEffect(() => {
        const fetchData = async () => {
            const { data } = await axios.get<IResponse<IVersion>>(`${API_ROUTE}/${id}`);
            form.setValues(data.result)
            form.resetDirty();
        }
        void fetchData();
    }, []);

    const handleSubmit = async (values: typeof form.values) => {
        const { data } = await axios.post<IResponse<any>>(`${API_ROUTE}/${id}`, values);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green')
        } else {
            showMessage('Алдаа гарлаа')
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} засах`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto">

                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <TextInput
                            withAsterisk
                            label="Үйлдлийн систем"
                            placeholder="Үйлдлийн систем"
                            disabled
                            {...form.getInputProps('os')}
                        />

                        <TextInput
                            withAsterisk
                            label="Хувилбарын код"
                            placeholder="Хувилбарын код уу"
                            {...form.getInputProps('versionCode')}
                        />

                        <NumberInput
                            withAsterisk
                            label="Хувилбарын дугаар"
                            placeholder="Хувилбарын дугаар уу"
                            {...form.getInputProps('versionNumber')}
                        />

                        <Switch
                            label="Is Force Update"
                            {...form.getInputProps('isForceUpdate', { type: 'checkbox' })}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default EditBanner;